import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { UitkCardMedia } from 'uitk-react-cards';

import { QueuedImage } from 'components/common/media/queued-image';
import { HotelViewModel } from 'models';

export interface ListingErrorBoundaryProps {
  thumbnail: HotelViewModel['thumbnail'];
  name: string;
}

export const ListingErrorBoundary: React.FunctionComponent<ListingErrorBoundaryProps> = ({ thumbnail, name, ...rest }) => {
  const innerH3ClassNames = [
    'uitk-cell',
    'all-cell-align-bottom',
    'uitk-type-500',
    'uitk-type-medium',
    'pwa-theme--color-white',
    'title__heading',
    'truncate'
  ];

  return (
    <ErrorBoundary
      label="hotel.search.listing.title"
      fallback={
        <header className="listing__title title">
          <UitkCardMedia>
            <QueuedImage className="uitk-grid title__media image-loader" src={(thumbnail && thumbnail.src) || ''} useBackgroundImage={true}>
              <h3 className={innerH3ClassNames.join(' ')} data-stid="content-hotel-title">
                {name}
              </h3>
            </QueuedImage>
          </UitkCardMedia>
        </header>
      }
      {...rest}
    />
  );
};
